import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";
import { GetUserPageParams } from "apis/data-contracts";

const useUsersSearchQuery = (options: GetUserPageParams) => {
  return useSuspenseQuery({
    queryKey: api.user.getUserPageKey(options),
    queryFn: () => api.user.getUserPage(options),
  });
};

export default useUsersSearchQuery;
